import store from "@/store";

export function isVerifiedInsurance() {
    return (
        store.getters.payment?.insuranceCoverage?.isVerified ||
        store.getters.order?.referralNumber?.length === 6
    );
}
